<!--pre>{{ notifications() | json }}</pre-->
<div class="mt-6 mx-4 sm:mx-0">
  @for (notification of notifications(); track notification.name) {
    <button
      class="soft-button"
      (click)="inputValue.set(notification.content)"
      class="border-b mb-4 hover:bg-hover"
    >
      {{ notification.content }}
    </button>
  }

  <soft-multiline-input class="mt-4" [(value)]="inputValue"></soft-multiline-input>
  <soft-input class="mt-4" placeholder="Telefonnummer" [(value)]="phone"> </soft-input>
</div>
<div class="flex flex-row gap-2 mt-2 w-full">
  <button class="soft-button secondary w-full mt-4" (click)="this.resolve('DISMISSED')">
    Abbrechen
  </button>
  <button
    class="soft-button primary w-full mt-4"
    (click)="inputValue() && this.resolve({ content: inputValue()!, phone: phone()! })"
  >
    SMS Senden
  </button>
</div>
